<div
  class="base-layout"
  [class.base-layout--nav-open]="mobileNavOpen()"
  [class.base-layout--collapsed]="sidebarCollapsed()"
>
  <!-- mobile top bar (only visible <768px) -->
  <header class="base-layout__topbar">
    <button
      type="button"
      class="base-layout__menu-button"
      [attr.aria-expanded]="mobileNavOpen()"
      aria-label="Toggle navigation"
      (click)="toggleMobileNav()"
    >
      <span class="material-icons">{{ mobileNavOpen() ? 'close' : 'menu' }}</span>
    </button>
    <span class="base-layout__brand">Hypecast</span>
  </header>
  <!-- /mobile top bar -->

  <!-- backdrop (mobile, when drawer open) -->
  <button type="button" class="base-layout__backdrop" aria-label="Close navigation" (click)="closeMobileNav()"></button>

  <!-- side-bar -->
  <aside class="base-layout__sidebar bg-white flex-initial flex flex-col border-solid border-r border-gray-100">
    <!-- collapse toggle (desktop only) -->
    <button
      type="button"
      class="base-layout__collapse-button"
      [attr.aria-pressed]="sidebarCollapsed()"
      [attr.aria-label]="sidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [title]="sidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      (click)="toggleSidebar()"
    >
      <span class="material-icons">{{ sidebarCollapsed() ? 'chevron_right' : 'chevron_left' }}</span>
    </button>

    <!-- side-bar__user-info -->
    <div class="base-layout__user-info flex-initial p-5 pl-6 pr-6 border-solid border-b-2 border-gray-100">
      <hypecast-master-admin-user-info></hypecast-master-admin-user-info>
    </div>
    <!-- /side-bar__user-info -->

    <!-- side-bar__navigation -->
    <div class="base-layout__navigation flex-auto p-5 pt-6 pb-6">
      <hypecast-master-admin-navigation></hypecast-master-admin-navigation>
    </div>
    <!-- /side-bar__navigation -->

    <!-- side-bar__actions -->
    <div
      class="base-layout__actions flex-initial p-4 pl-6 pr-6 border-solid border-t-2 border-gray-100 box-shadow--top"
    >
      <hypecast-master-admin-actions></hypecast-master-admin-actions>
    </div>
    <!-- /side-bar__actions -->
  </aside>
  <!-- /side-bar -->

  <!-- SPACER -->
  <div class="base-layout__sidebar-spacer flex-initial"></div>

  <!-- content -->
  <main class="base-layout__main flex-auto bg-gray-50">
    <router-outlet></router-outlet>
  </main>
  <!-- /content -->
</div>
